import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Button, Typography } from "@mui/material";
import React, { useEffect } from "react";
import TeamsTable from "../../components/TeamsTable";
import { useDispatch, useSelector } from "react-redux";
import { deleteTeam, getTeamDetails, saveTeamDetails } from "../../api/dataCapture";
import { resetSelectedTeam, setIsUpdatedTeam, setTeamDetails } from "../../redux/reducers/dataCaptures";
import AddTeamDetailsForm from "../AddTeamDetailsForm";
import TeamDetailPage from "../TeamDetailPage";

const TeamsDetails = () => {
    const [addTeam, setAddTeam] = React.useState(false);
    const dispatch = useDispatch();
    const clubDetails = useSelector((state:any) => state.clubDetails);
    const selectedTeam = useSelector((state:any) => state.dataCaptures.selectedTeam);
    const data = useSelector((state:any) => state.dataCaptures.teamDetails);
    const isUpdatedTeam = useSelector((state:any) => state.dataCaptures.isUpdatedTeam);
    const isAdmin = useSelector((state:any) => state.common.isAdmin);
    
    const fetchTeamDetails = async () => {
        const response = await getTeamDetails({clubId: clubDetails.id, isPast: false});
        dispatch(setTeamDetails(response));
    }

    useEffect(() => {
        fetchTeamDetails();
    }, []);

  const manageTeamDetailsClose = async () => {
        if (isUpdatedTeam) {
            const updatedList = data?.map((item:any) => item?.id == selectedTeam?.id ? selectedTeam : item);
            const response = await saveTeamDetails({clubId: clubDetails?.id, data: updatedList});
            dispatch(setTeamDetails(response));
            const boolean:any = false;
            dispatch(setIsUpdatedTeam(boolean));
        }
        dispatch(resetSelectedTeam());
    }

  const manageDeleteRow = (row: any) => {
    deleteTeam({ clubId: clubDetails?.id, id: row?.id }).then(() => {
    fetchTeamDetails();
    })
  }
    return (
        <Box>
            {!isAdmin && addTeam && <AddTeamDetailsForm onCancelClick={() => {setAddTeam(false)}}/>}
            <TeamDetailPage isOpen={selectedTeam && Object.keys(selectedTeam).length > 0} handleClose={manageTeamDetailsClose} />
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                <Typography className='standardsHeading uppercase'>teams</Typography>
                {
                    !isAdmin &&
                    <Button className='smallButton' 
                    sx={{ float: 'right' }} 
                    disableElevation disabled={addTeam} 
                    variant='contained' size='small' 
                    onClick={() => {setAddTeam(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                        {'Add team'}
                    </Button>
                }
            </Box>
            <TeamsTable addData={addTeam} handleClick={() => setAddTeam(false)} manageDeleteRow={manageDeleteRow} />
        </Box>
    )
}

export default TeamsDetails;